
import { Vue, Component, Prop, ModelSync } from "vue-property-decorator";
import { Control } from "@/oxygen/classes/lib/types";
import { Variable } from "@/oxygen/variables/lib/types";
import OverrideVariablesInput from "@/oxygen/variables/OverrideVariablesInput.vue";

@Component({
  components: {
    OverrideVariablesInput
  }
})
export default class OxygenVariablesInput extends Vue {
  @Prop()
  control!: Control;

  @ModelSync("value", "input", { type: Array })
  syncedValue?: Variable[];
}
